import React, { useEffect, useState } from "react";
import { Container, Typography, Box, CircularProgress } from "@mui/material";
import ReactMarkdown from "react-markdown";

const PrivacyPolicyPage = () => {
  const [policyText, setPolicyText] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch("/privacy_policy.md")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load privacy policy.");
        return res.text();
      })
      .then((text) => {
        setPolicyText(text);
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to load privacy policy.");
        setLoading(false);
      });
  }, []);

  return (
    <Container maxWidth="md" sx={{ mt: 6, mb: 6, fontFamily: 'Roboto, Arial, sans-serif' }}>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" color="#492099" gutterBottom>
          Privacy Policy
        </Typography>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <Box sx={{ fontFamily: 'Roboto, Arial, sans-serif' }}>
          <ReactMarkdown>{policyText}</ReactMarkdown>
        </Box>
      )}
    </Container>
  );
};

export default PrivacyPolicyPage;
